/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_TitleInputs */

const en_pc_alt_title = /** @type {(inputs: Pc_Alt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft alternatives`)
};

const zh_pc_alt_title = /** @type {(inputs: Pc_Alt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft 替代方案`)
};

/**
* | output |
* | --- |
* | "PdfCraft alternatives" |
*
* @param {Pc_Alt_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_title = /** @type {((inputs?: Pc_Alt_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_title(inputs)
	return zh_pc_alt_title(inputs)
});
export { pc_alt_title as "pc.alt.title" }